export default {
  sm: `
  선조들의 지혜로부터
  시작된 그린 데이터센터
  `,
  lg: `
  선조들의 지혜로부터 시작된
  그린 데이터센터
  `
};
